import { render, staticRenderFns } from "./history__operation.vue?vue&type=template&id=20dff781"
import script from "./history__operation.vue?vue&type=script&lang=js"
export * from "./history__operation.vue?vue&type=script&lang=js"
import style0 from "./history__operation.vue?vue&type=style&index=0&id=20dff781&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports